export default function validateCPF(cpf) {
  cpf = cpf.replace(/\D+/g, '');

  if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;

  const calcDigit = (factor) => {
    const sum = cpf.slice(0, factor - 1).split('').reduce((sum, num, index) => sum + num * (factor - index), 0);
    return (sum * 10) % 11 % 10;
  };

  return calcDigit(10) === +cpf[9] && calcDigit(11) === +cpf[10];
}

export function validateCNPJ(cnpj) {
  cnpj = cnpj.replace(/\D+/g, '');

  if (cnpj.length !== 14 || /^(\d)\1{13}$/.test(cnpj)) return false;

  const calcDigit = (length) => {
    const factors = Array.from({ length }, (_, i) => i % 8 + 2).reverse();
    const sum = cnpj.slice(0, length).split('').reduce((acc, num, idx) => acc + num * factors[idx], 0);
    return sum % 11 < 2 ? 0 : 11 - (sum % 11);
  };

  return calcDigit(12) === +cnpj[12] && calcDigit(13) === +cnpj[13];
}
